import type { FaireProductEntity } from "../../entity_types/product";

export const p_g6796vs8nu: FaireProductEntity = {
  token: "p_g6796vs8nu",
  type: "product",
  name: "KD-TP1000 Kids Print Baby Doll Top - Black Camo",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/1c29c2f60a6181354c578d7bef33eb1f7d79246da80081a4f59c7a96a83c2e0b.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description: "This kids' camo print baby doll top from Girlie Girl Originals features a black camo print and a baby doll silhouette, offering a stylish option for children's wardrobes. It is a kids T-shirt by Girlie Girl Originals, a brand known for bold and fun apparel with a southern flair.",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:53.515Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
